<template>
  <v-app>
    <Snackbar />
    <v-main>
      <router-view />
      <app-version-mismatch></app-version-mismatch>
    </v-main>
    
  </v-app>
</template>

<script>
import { Snackbar, AppVersionMismatch } from "@/components";
export default {
  name: "App",
  components: {
    Snackbar,
    AppVersionMismatch
  },
  data: () => ({
    //
  })
};
</script>
